import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.407 15.893a1 1 0 0 1-1.414 0l-1.886-1.886a1 1 0 0 1 0-1.414l5.736-5.736a1 1 0 0 1 1.414 0l1.886 1.886a1 1 0 0 1 0 1.414l-5.736 5.736Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.175 6.175c-.511-.511-.152-1.382.57-1.38l7.632.017c.447 0 .81.364.811.811l.018 7.633c.001.72-.87 1.08-1.38.569l-7.651-7.65Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ThickDiagonalArrowIcon20.js.map